import React from 'react';
import { render } from 'react-dom'
import { Provider } from "react-redux"
import { Router, Route} from 'react-router'


import { configureStore } from "./Store"



import Home from './modules/home/home.jsx';


import createBrowserHistory from 'history/createBrowserHistory'

import './App.css';



const newHistory = createBrowserHistory();

const store = configureStore();

var routes = (
  <Provider store={store}>
    <Router history={newHistory}>
    <div>
       
        <Route exact path="/"  component={Home} > </Route>
   	
     
       </div>
    </Router>
  </Provider>
  );

let startApp = () => {
  render(routes, document.getElementById('root'));
}

startApp();


// WEBPACK FOOTER //
// ./src/index.js